import React from 'react';
import { CaretLeftIcon } from '@stashinvest/react-assets';
import { ButtonIcon, ButtonStandard, Text } from '@stashinvest/react-components';
import { MixSwatch } from './MixSwatch';
import { StepChecklist, type StepChecklistItem } from './StepChecklist';

const TITLE_ID = 'saved-mix-primer-title';
const HEADING = "Let's make your first investment!";

const STEPS: StepChecklistItem[] = [
	{ title: 'Build your mix', detail: 'Complete!', complete: true },
	{ title: 'Confirm your identity', detail: 'Complete!', complete: true },
	{ title: 'Set up investor profile', detail: 'Complete!', complete: true },
	{ title: 'Make investment', detail: 'Up next', muted: true },
];

type SavedMixPrimerProps = {
	mixName: string;
	onInvest: () => void;
	onMakeNewMix: () => void;
	onBack: () => void;
};

function SavedMixPrimer({
	mixName,
	onInvest,
	onMakeNewMix,
	onBack,
}: SavedMixPrimerProps) {
	return (
		<div
			aria-labelledby={TITLE_ID}
			className="min-h-screen bg-containerLow"
			data-testid="saved-mix-primer"
			role="dialog"
		>
			<div className="mx-auto flex w-full max-w-[375px] flex-col px-contentMedium pb-contentLarge pt-contentXS">
				<div className="-ml-content2XS">
					<ButtonIcon
						Icon={CaretLeftIcon}
						altText="Back"
						onClick={onBack}
						size="standard"
						variant="tertiary"
					/>
				</div>

				<Text
					className="mt-contentSmall whitespace-nowrap text-black"
					id={TITLE_ID}
					tag="h1"
					textAlign="left"
					textStyle="headerXS"
				>
					{HEADING}
				</Text>
				<Text className="mt-content2XS text-black" tag="p" textAlign="left" textStyle="bodyMediumStandard">
					Invest in your new custom mix, you can always update this before purchasing
				</Text>

				<div className="mt-contentMedium flex h-[199px] w-full flex-col items-center justify-center gap-contentSmall rounded-[8px] border border-solid border-outlineVariant bg-containerLowest shadow-[0px_4px_31px_0px_rgba(0,0,0,0.15)]">
					<MixSwatch />
					<Text tag="p" textAlign="center" textStyle="headerXS" className="text-onSurface">
						{mixName}
					</Text>
				</div>

				<div className="mt-layoutSmall w-full pl-contentMedium">
					<StepChecklist steps={STEPS} />
				</div>

				<div className="mt-contentLarge flex flex-col items-center gap-content2XS">
					<ButtonStandard
						className="!w-full"
						data-testid="saved-mix-primer-invest"
						onClick={onInvest}
						size="XL"
						variant="inverseSecondary"
					>
						Invest in my mix
					</ButtonStandard>
					<ButtonStandard
						data-testid="saved-mix-primer-new-mix"
						onClick={onMakeNewMix}
						size="XL"
						variant="tertiary"
					>
						Make new mix
					</ButtonStandard>
				</div>
			</div>
		</div>
	);
}

export default SavedMixPrimer;
